import { Component } from "@angular/core";
import { ConfigService } from "../../services/config/config.service";

@Component({
    selector: 'app-timeout-error-message',
    templateUrl: './timeout-error-message.component.html',
    styleUrls: ['./timeout-error-message.component.scss']
  })

export class TimeoutErrorMessageComponent {
  errorText: string;

  constructor(private configService: ConfigService) {
    this.errorText = this.configService.timeoutErrorMessage;
  }
}